import { Game } from '@Game/Game';
import { GameStore } from '@GameStore/GameStore';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';
import { IActionResponseData } from '@GFTypes/Responses/ActionResponse';
import { EActionName } from '@Managers/Events/EActionName';
import EventsCenter from '@Managers/Events/EventsCenter';
import { EGameEvents } from '@Managers/Events/GameEvents';
import { EGameStates } from '@Managers/StateManager/GameStates';
import { processFreeGamesSpinData } from '../Data/FreeGamesDataProcessor';
import { processLockAndRollSpinData } from '../Data/LockAndRollDataProcessor';
import { processGambleResponse } from './GambleResponseProcessor';
import { processSpinResponse } from './SpinResponseProcessor';

export const processActionResponse = (data: IActionResponseData & { actionName: EActionName }, gameStore: GameStore, game: Game) => {
    gameStore.set(EGameStoreKeys.NextActions, data.result.nextActions);

    if (data.actionName === EActionName.SPIN || data.actionName === EActionName.BONUS_BUY_SPIN) {
        const processedOutcome = processSpinResponse(data);
        const processedFreeGames = processFreeGamesSpinData(processedOutcome);
        const processedLockAndRoll = processLockAndRollSpinData(processedOutcome);

        gameStore.set(EGameStoreKeys.OriginalSpinResponse, { ...data });
        gameStore.set(EGameStoreKeys.SpinOutcome, processedOutcome);

        if (data.jackpotHit) {
            console.warn('process jackpot hit for current user', data.jackpotHit); // TO DO !!!!!
            gameStore.set(EGameStoreKeys.JackpotCasinoState, { userHit: data.jackpotHit }, true);
        }
        if (processedFreeGames) gameStore.set(EGameStoreKeys.FreeGames, processedFreeGames, true);
        if (processedLockAndRoll) gameStore.set(EGameStoreKeys.LockAndRoll, processedLockAndRoll, true);

        EventsCenter.emit(EGameEvents.ACTION_RESPONSE_PROCESSED, { actionName: data.actionName });
    }

    if (data.actionName === EActionName.GAMBLE) {
        gameStore.set(EGameStoreKeys.GambleResponse, processGambleResponse(data));
        EventsCenter.emit(EGameEvents.ACTION_RESPONSE_PROCESSED, { actionName: data.actionName });
    }

    if (data.actionName === EActionName.TAKE) {
        gameStore.set(EGameStoreKeys.IsTakeCompleted, true);

        if (gameStore.get(EGameStoreKeys.CurrentGameState) === EGameStates.SPIN_STATE) {
            gameStore.set(EGameStoreKeys.GeneralAppState, {
                insufficientFunds: !gameStore.get(EGameStoreKeys.BetState).available && game.betManager.getCurrentSpinBet() > 0
            });
            EventsCenter.emit(EGameEvents.SEND_ACTION_REQUEST, {
                actionName: EActionName.SPIN,
                bet: game.betManager.getCurrentSpinBet()
            });
        }
    }
};
